import React from "react";
import { Link } from "react-router-dom";
import line from "../assets/line.png";

import Sr1 from "../assets/sr1.png";
import Sr2 from "../assets/sr2.png";
import Sr3 from "../assets/sr3.png";

const ServiceSection = () => {
  const products = [
    {
      img: Sr1,
      title: "Medical Coding",
      desc: "Comprehensive hospital management for streamlined operations.",
      link: "/Medical",
    },
    {
      img: Sr2,
      title: "Image Analysis",
      desc: "Comprehensive hospital management for streamlined operations.",
      link: "/Analysis",
    },
    {
      img: Sr3,
      title: "Anomaly Detection",
      desc: "Comprehensive hospital management for streamlined operations.",
      link: "/Detection",
    },
  ];

  return (
    <div className="mt-10 px-4 sm:px-6 md:px-10">
      {/* Section Heading (Left Aligned) */}
      <div className="mb-6 text-left">
        <div className="relative inline-block pb-2">
          <span className="relative z-10 font-bold text-xl md:text-2xl lg:text-3xl">
            <span className="text-[#0077cc]">WISE</span> Service Offerings
          </span>
          <img
            src={line}
            alt="underline"
            className="absolute left-0 bottom-0 h-[6px] w-full object-contain"
          />
        </div>
      </div>

      {/* Responsive Grid */}
      <div className="flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-10 lg:gap-12 max-w-6xl w-full">
          {products.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-lg shadow hover:shadow-lg transition-all duration-300 bg-white"
            >
              {/* Image */}
              <img
                src={item.img}
                alt={item.title}
                className="h-20 sm:h-24 md:h-28 lg:h-32 mb-4 object-contain"
              />

              {/* Bold Heading (all black) */}
              <h3 className="font-bold text-base sm:text-lg md:text-xl text-black mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-4 leading-relaxed">
                {item.desc}
              </p>

              {/* Link Button */}
              <Link
  to={item.link}
  className="
    inline-block px-6 py-3 
    border-2 border-purple-400 
    text-purple-600 
    bg-white 
    rounded-md
    font-semibold text-base md:text-lg
    hover:bg-[#4B0082] hover:text-white hover:border-[#4B0082]
    transition-all duration-200
  "
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Know More
</Link>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;